<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h5 class="info-text">{{$lang.titles.data_structure_settinsg}}</h5>
    </div>

    <div class="md-layout-item md-size-100">
      <div v-for="row in checkBoxPerPhase" :key="row.name" class="md-layout">
        <label class="md-layout-item md-xsmall-size-25 md-size-20 md-form-label">{{row.name}}</label>
        <div
          v-for="item in row.keys"
          :key="item.key"
          class="md-layout-item md-xsmall-size-25 md-size-10 mx-auto"
        >
          <md-checkbox
            v-model="settings.map"
            :value="item.key"
            :disabled="item.disabled"
          >{{item.name}}</md-checkbox>
        </div>
        <label class="md-layout-item md-xsmall-size-10 md-size-5 md-form-label">{{row.unit}}</label>
      </div>

      <br />
      <h4 class="title">{{$lang.charts.cumulative}}</h4>
      <div class="md-layout">
        <div
          v-for="item in checkBoxData.cumulatives"
          :key="item.key"
          class="md-layout-item md-xsmall-size-50 md-medium-size-25 md-size-20"
        >
          <md-checkbox
            v-model="settings.map"
            :value="item.key"
            :title="item.tooltip"
            :disabled="item.disabled"
          >{{item.name}}</md-checkbox>
        </div>
      </div>

      <br />
      <h4 class="title">{{$lang.tooltip.reactive_energy}}</h4>
      <div class="md-layout">
        <div
          v-for="item in checkBoxData.reactive_energy"
          :key="item.key"
          class="md-layout-item md-xsmall-size-50 md-medium-size-25 md-size-20"
        >
          <md-checkbox
            v-model="settings.map"
            :value="item.key"
            :title="item.tooltip"
            :disabled="item.disabled"
          >{{item.name}}</md-checkbox>
        </div>
      </div>

      <br />
      <h4 class="title">{{$lang.charts.other}}</h4>
      <div class="md-layout">
        <div
          v-for="item in checkBoxData.others"
          :key="item.key"
          class="md-layout-item md-xsmall-size-50 md-medium-size-25 md-size-20"
        >
          <md-checkbox
            v-model="settings.map"
            :value="item.key"
            :title="item.tooltip"
            :disabled="item.disabled"
          >{{item.name}}</md-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      default: {
        supported: [],
        map: []
      }
    },
    SF: String
  },
  data() {
    return {
      checkBoxPerPhase: [
        {
          name: this.$lang.menu.voltage,
          unit: "mV",
          keys: [
            {
              name: "L1",
              key: "VA",
              disabled: true
            },
            {
              name: "L2",
              key: "VB",
              disabled: true
            },
            {
              name: "L3",
              key: "VC",
              disabled: true
            }
          ]
        },
        {
          name: this.$lang.menu.current,
          unit: "mA",
          keys: [
            {
              name: "L1",
              key: "IA",
              disabled: true
            },
            {
              name: "L2",
              key: "IB",
              disabled: true
            },
            {
              name: "L3",
              key: "IC",
              disabled: true
            }
          ]
        },
        {
          name: this.$lang.menu.active_power,
          unit: "mW",
          keys: [
            {
              name: "L1",
              key: "PA",
              disabled: true
            },
            {
              name: "L2",
              key: "PB",
              disabled: true
            },
            {
              name: "L3",
              key: "PC",
              disabled: true
            }
          ]
        },
        {
          name: this.$lang.menu.reactive_power,
          unit: "mVAr",
          keys: [
            {
              name: "L1",
              key: "QA",
              disabled: true
            },
            {
              name: "L2",
              key: "QB",
              disabled: true
            },
            {
              name: "L3",
              key: "QC",
              disabled: true
            }
          ]
        },
        {
          name: this.$lang.menu.apparent_power,
          unit: "mVA",
          keys: [
            {
              name: "L1",
              key: "SA",
              disabled: true
            },
            {
              name: "L2",
              key: "SB",
              disabled: true
            },
            {
              name: "L3",
              key: "SC",
              disabled: true
            }
          ]
        },
        {
          name: this.$lang.menu.power_factor,
          unit: "",
          keys: [
            {
              name: "L1",
              key: "PFA",
              disabled: true
            },
            {
              name: "L2",
              key: "PFB",
              disabled: true
            },
            {
              name: "L3",
              key: "PFC",
              disabled: true
            }
          ]
        },
        {
          name: this.$lang.charts.average_voltage,
          unit: "mV",
          keys: [
            {
              name: "L1",
              key: "AvgVA",
              disabled: true
            },
            {
              name: "L2",
              key: "AvgVB",
              disabled: true
            },
            {
              name: "L3",
              key: "AvgVC",
              disabled: true
            }
          ]
        },
        {
          name: this.$lang.charts.average_current,
          unit: "mA",
          keys: [
            {
              name: "L1",
              key: "AvgIA",
              disabled: true
            },
            {
              name: "L2",
              key: "AvgIB",
              disabled: true
            },
            {
              name: "L3",
              key: "AvgIC",
              disabled: true
            }
          ]
        },
        {
          name: this.$lang.charts.average_active_power,
          unit: "mW",
          keys: [
            {
              name: "L1",
              key: "AVGPA",
              disabled: true
            },
            {
              name: "L2",
              key: "AVGPB",
              disabled: true
            },
            {
              name: "L3",
              key: "AVGPC",
              disabled: true
            }
          ]
        },
        {
          name: this.$lang.charts.active_energy_import,
          unit: "SCALER",
          keys: [
            {
              name: "L1",
              key: "TEINA",
              disabled: true
            },
            {
              name: "L2",
              key: "TEINB",
              disabled: true
            },
            {
              name: "L3",
              key: "TEINC",
              disabled: true
            }
          ]
        },
        {
          name: this.$lang.charts.active_energy_export,
          unit: "SCALER",
          keys: [
            {
              name: "L1",
              key: "TEOUTA",
              disabled: true
            },
            {
              name: "L2",
              key: "TEOUTB",
              disabled: true
            },
            {
              name: "L3",
              key: "TEOUTC",
              disabled: true
            }
          ]
        }
      ],
      checkBoxData: {
        cumulatives: [
          {
            name: "CUMI",
            key: "CUMI",
            tooltip: this.$lang.tooltip.cumulative_current,
            disabled: true
          },
          {
            name: "CUMP",
            key: "CUMP",
            tooltip: this.$lang.tooltip.cumulative_active_power,
            disabled: true
          },
          {
            name: "CUMQ",
            key: "CUMQ",
            tooltip: this.$lang.tooltip.cumulative_reactive_power,
            disabled: true
          },
          {
            name: "CUMS",
            key: "CUMS",
            tooltip: this.$lang.tooltip.cumulative_apparent_power,
            disabled: true
          },
          {
            name: "CUMEI",
            key: "CUMEI",
            tooltip: this.$lang.tooltip.cumulative_energy_import,
            disabled: true
          },
          {
            name: "CUMEO",
            key: "CUMEO",
            tooltip: this.$lang.tooltip.cumulative_energy_export,
            disabled: true
          },
          {
            name: "AAVGU",
            key: "AAVGU",
            tooltip: this.$lang.tooltip.average_of_average_voltages,
            disabled: true
          },
          {
            name: "CUMAVGI",
            key: "CUMAVGI",
            tooltip: this.$lang.tooltip.cumulative_average_current,
            disabled: true
          },
          {
            name: "CUMAVGP",
            key: "CUMAVGP",
            tooltip: this.$lang.tooltip.cumulative_average_active_power,
            disabled: true
          }
        ],
        reactive_energy: [
          {
            name: "TER1QA",
            key: "TER1QA",
            tooltip: this.$lang.tooltip.reactive_energy + " L1 " + this.$lang.tooltip.quadrant + " 1",
            disabled: true
          },
          {
            name: "TER2QA",
            key: "TER2QA",
            tooltip: this.$lang.tooltip.reactive_energy + " L1 " + this.$lang.tooltip.quadrant + " 2",
            disabled: true
          },
          {
            name: "TER3QA",
            key: "TER3QA",
            tooltip: this.$lang.tooltip.reactive_energy + " L1 " + this.$lang.tooltip.quadrant + " 3",
            disabled: true
          },
          {
            name: "TER4QA",
            key: "TER4QA",
            tooltip: this.$lang.tooltip.reactive_energy + " L1 " + this.$lang.tooltip.quadrant + " 4",
            disabled: true
          },
          {
            name: "TER1QB",
            key: "TER1QB",
            tooltip: this.$lang.tooltip.reactive_energy + " L2 " + this.$lang.tooltip.quadrant + " 1",
            disabled: true
          },
          {
            name: "TER2QB",
            key: "TER2QB",
            tooltip: this.$lang.tooltip.reactive_energy + " L2 " + this.$lang.tooltip.quadrant + " 2",
            disabled: true
          },
          {
            name: "TER3QB",
            key: "TER3QB",
            tooltip: this.$lang.tooltip.reactive_energy + " L2 " + this.$lang.tooltip.quadrant + " 3",
            disabled: true
          },
          {
            name: "TER4QB",
            key: "TER4QB",
            tooltip: this.$lang.tooltip.reactive_energy + " L2 " + this.$lang.tooltip.quadrant + " 4",
            disabled: true
          },
          {
            name: "TER1QC",
            key: "TER1QC",
            tooltip: this.$lang.tooltip.reactive_energy + " L3 " + this.$lang.tooltip.quadrant + " 1",
            disabled: true
          },
          {
            name: "TER2QC",
            key: "TER2QC",
            tooltip: this.$lang.tooltip.reactive_energy + " L3 " + this.$lang.tooltip.quadrant + " 2",
            disabled: true
          },
          {
            name: "TER3QC",
            key: "TER3QC",
            tooltip: this.$lang.tooltip.reactive_energy + " L3 " + this.$lang.tooltip.quadrant + " 3",
            disabled: true
          },
          {
            name: "TER4QC",
            key: "TER4QC",
            tooltip: this.$lang.tooltip.reactive_energy + " L3 " + this.$lang.tooltip.quadrant + " 4",
            disabled: true
          },
          {
            name: "TERI",
            key: "TERI",
            tooltip: this.$lang.tooltip.overall_reactive_energy_import,
            disabled: true
          },
          {
            name: "TERE",
            key: "TERE",
            tooltip: this.$lang.tooltip.overall_reactive_energy_export,
            disabled: true
          }
        ],
        others: [
          {
            name: "ScaleT",
            key: "SCALT",
            tooltip: this.$lang.tooltip.time_scaler,
            disabled: true
          },
          {
            name: "ScaleP",
            key: "SCALP",
            tooltip: this.$lang.tooltip.power_scaler,
            disabled: true
          },
          {
            name: "LRSSI",
            key: "LRRSI",
            tooltip: this.$lang.tooltip.lora_rssi,
            disabled: true
          },
          {
            name: "WRSSI",
            key: "WRRSI",
            tooltip: this.$lang.tooltip.wifi_rssi,
            disabled: true
          }
        ]
      }
    };
  },

  watch: {
    "settings.supported"() {
      this.testSupportedPayload();
    },
    "settings.map"() {
      this.testMaximumPayload();
    },
    SF() {
      this.testMaximumPayload();
    }
  },

  methods: {
    testSupportedPayload() {
      let webSupportedData = [];

      this.checkBoxPerPhase.forEach(row => {
        row.keys.forEach(dataValue => {
          webSupportedData.push(dataValue.key);

          const valueIndex = this.settings.supported.findIndex(
            e => e === dataValue.key
          );
          if (valueIndex !== -1) {
            dataValue.disabled = false;
          } else {
            dataValue.disabled = true;
          }
        });
      });

      Object.keys(this.checkBoxData).forEach(section => {
        this.checkBoxData[section].forEach(dataValue => {
          webSupportedData.push(dataValue.key);

          const valueIndex = this.settings.supported.findIndex(
            e => e === dataValue.key
          );
          if (valueIndex !== -1) {
            dataValue.disabled = false;
          } else {
            dataValue.disabled = true;
          }
        });
      });

    
      this.settings.map.forEach((property, index) => {
          if (webSupportedData.findIndex(e => e === property) === -1){
            this.settings.map.splice(index, 1);
          }
      });
      


    },

    testMaximumPayload() {
      let maximum = false;
      switch (parseInt(this.SF)) {
        case 0:
        case 1:
        case 2:
          if (this.settings.map.length == 10) {
            maximum = true;
          }
          if (this.settings.map.length > 10) {
            this.settings.map = [];
            return;
          }
          break;
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          if (this.settings.map.length == 22) {
            maximum = true;
          }
          if (this.settings.map.length > 22) {
            this.settings.map = [];
            return;
          }
          break;
      }

      this.checkBoxPerPhase.forEach(row => {
        row.keys.forEach(dataValue => {
          if (maximum === true) {
            if (this.settings.map.findIndex(e => e == dataValue.key) === -1) {
              dataValue.disabled = true;
            }
          } else {
            dataValue.disabled = false;
          }
        });
      });

      Object.keys(this.checkBoxData).forEach(section => {
        this.checkBoxData[section].forEach(dataValue => {
          if (maximum === true) {
            if (this.settings.map.findIndex(e => e == dataValue.key) === -1) {
              dataValue.disabled = true;
            }
          } else {
            dataValue.disabled = false;
          }
        });
      });
    },

    validate() {
      this.$emit("on-validated", true, { MAP: this.settings.map }, true);
      return Promise.resolve(true);
    }
  }
};
</script>